// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__QNeU9"};